<template>
  <div class="col-md-12 job-card">
    <p>Documents & Skills</p>

    <button type="button"  class="btn btn-secondary" v-if="app.document" @click="getApplicationDocument(app.document)">Download CV</button>
    <button type="button"  class="btn btn-secondary" v-if="app.applicationSkills.length > 0" @click="openSkill()">Check Skill Result</button>
  </div>
</template>

<script>
import { organizationService } from "@/services/organizationService";
export default {
  name: "documents-card",
  props: {
         app: {},
         currentOffice: {},
         openSkill: { type: Function }
  },
  methods: {
    getApplicationDocument(file) {
      organizationService.getPolicyDocument(file).then(
        (response) => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        (error) => {
          error = error;
        }
      );
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/applications/documents-card.vue